export const prefix = "bat"
export const iconName = "italic"
export const width = 13
export const height = 16
export const ligatures = []
export const unicode = ""
export const svgPathData =
    "M4.65522 0.624023V3.73018H6.94342L3.4024 12.0133H0.513672V15.1194H8.79676V12.0133H6.50856L10.0496 3.73018H12.9383V0.624023H4.65522Z"
export const definition = {
    prefix,
    iconName,
    icon: [width, height, ligatures, unicode, svgPathData],
}

export const batItalic = definition
